// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qjD_","newExpiryDate":"styles_newExpiryDate__3iiop","footer":"styles_footer__WEm9T"};